<aw-dialog
  (onClose)="dialogRef.close($event)"
  [content]="content"
  [footer]="footer"
  [width]="width"
  [data]="data"
  [icon]="data.icon"
  [iconBackgroundColor]="data.iconBackgroundColor"
  [title]="data.headline"
  [fontSize]="data.fontSize | toFontSize">
  <ng-template #content>
    <div class="flex w-full justify-center">
      <img [src]="imageStore.getImagePath(imageId)" alt="Image Preview" />
    </div>
  </ng-template>
  <ng-template #footer> </ng-template>
</aw-dialog>
